// @flow
import { TOUR_INTRODUCTION } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_TOUR_INTRODUCTION } from 'Utils/request/requestDictionary';

export type TourIntroductionDescriptorProps = {
  highlightTitle: string,
  resortId: string,
  roadmapTitle: string,
};

export const tourIntroductionResolver = {
  name: TOUR_INTRODUCTION,
  resolve(appContext: AppContext, props: TourIntroductionDescriptorProps) {
    const { resortId } = props;
    const query = `query {
      resort(resortId: "${resortId}") {
        strengths
        details
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_TOUR_INTRODUCTION,
      strictErrors: false,
    });
  },
};
